export default __webpack_public_path__ + "static/media/005-feather-blue.e5623a84.svg";